export default __webpack_public_path__ + "static/media/verified.ee0582c0.svg";